/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_UpdatedInputs */

const en_bot_updated = /** @type {(inputs: Bot_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated 24 September 2026`)
};

const id_bot_updated = /** @type {(inputs: Bot_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diperbarui 24 September 2026`)
};

/**
* | output |
* | --- |
* | "Updated 24 September 2026" |
*
* @param {Bot_UpdatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_updated = /** @type {((inputs?: Bot_UpdatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_UpdatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_updated(inputs)
	return en_bot_updated(inputs)
});